module.exports = __webpack_public_path__ + "static/img/dealercardwebD.4c6b092.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/dealercardwebD.png
// module id = SSGX
// module chunks = 83